/**
 * constants
 * @type {{REGISTER: string, ORDER: string, PHONE: string, EDIT: string}}
 */
export const TYPES = {
	REGISTER: "REGISTER",
	EDIT: "EDIT",
	ORDER: "ORDER",
	PHONE: "PHONE"
}

let verifyPrefix = "BX.Efox.PremiumBonus.Phone:",
	bonusWriteOffPrefix = "BX.Efox.PremiumBonus.BonusWriteOff:",
	orderPrefix = "BX.Efox.PremiumBonus.Order:",
	balancePrefix = "BX.Efox.PremiumBonus.Balance:"
;

export const EVENTS = {
	VUE_INIT: "BX.Efox.PremiumBonus:vueInit",
	VUE_INIT_TIMEOUT: 1000,
	VERIFY: {
		OPEN: verifyPrefix + "open",
		BEFORE_OPEN: verifyPrefix + "beforeOpen",
		INITED: verifyPrefix + "inited",
		CLOSE: verifyPrefix + "close",
		SENDED: verifyPrefix + "sended",
		VERIFIED: verifyPrefix + "verified",
		ALREADY_VERIFIED: verifyPrefix + "alreadyVerified",
		SET_PHONE: verifyPrefix + "setPhone",
		PROPERTY_UPDATE: verifyPrefix + "propertyUpdate",
		SET_OPTIONS: verifyPrefix + "setOptions",
		NO_PHONE_VERIFY: verifyPrefix + "noPhoneVerify",
	},
	ORDER: {
		OPEN: orderPrefix + "open"
	},
	BONUS_WRITE_OFF: {
		OPEN: bonusWriteOffPrefix + "open",
		CLOSE: bonusWriteOffPrefix + "close",
		RELOAD: bonusWriteOffPrefix + "reload",
		UPDATED: bonusWriteOffPrefix + "updated",
		PROPERTY_UPDATE: bonusWriteOffPrefix + "propertyUpdate",
		INITED: bonusWriteOffPrefix + "inited",
	},
	BALANCE: {
		OPEN: balancePrefix + "open",
		CLOSE: balancePrefix + "close",
		RELOAD: balancePrefix + "reload",
		ERROR: balancePrefix + "errors"
	},
}

export const ORDER = {
	EVENTS: {
		ON_AJAX_SUCCESS: "onAjaxSuccess",
		INIT: "OnOrderFormInit",
		ON_BASKET_CHANGE: "OnBasketChange"
	},
	AJAX_URL: "/bitrix/components/bitrix/sale.order.ajax/ajax.php"
}

export const URLS = {
	VERIFY: "/bitrix/tools/efox.premiumbonus/phone.verify.form/",
	ORDER: "/bitrix/tools/efox.premiumbonus/order/",
	BALANCE: "/bitrix/tools/efox.premiumbonus/balance/",
}
